module.exports = __webpack_public_path__ + "ggvue/img/pic2.f25697bc.png";